import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const NativeContentPage = lazyWithRetry(() => import('./pages/NativeContentPage'))
const NativeContentCreatePage = lazyWithRetry(() => import('./pages/NativeContentCreatePage'))
const NativeContentDetailPage = lazyWithRetry(() => import('./pages/NativeContentDetailPage'))
const PersonalVoiceListPage = lazyWithRetry(() =>
  import('./pages/PersonalVoiceListPage').then((module) => ({
    default: module.PersonalVoiceListPage,
  })),
)
const PersonalVoiceFormPage = lazyWithRetry(() =>
  import('./pages/PersonalVoiceFormPage').then((module) => ({
    default: module.PersonalVoiceFormPage,
  })),
)

const routes: AppRoute[] = [
  {
    path: 'native-content',
    children: [
      {
        index: true,
        element: NativeContentPage,
        meta: {
          title: 'sidebarNav.nativeContent',
          require: { minRole: ROLE.MEMBER },
        },
      },
      {
        path: 'create',
        element: NativeContentCreatePage,
        meta: {
          title: 'sidebarNav.nativeContent',
          require: { minRole: ROLE.MEMBER },
        },
      },
      {
        path: 'voice',
        children: [
          {
            index: true,
            element: PersonalVoiceListPage,
            meta: {
              title: 'sidebarNav.nativeContent',
              require: { minRole: ROLE.MEMBER },
            },
          },
          {
            path: 'new',
            element: PersonalVoiceFormPage,
            meta: {
              title: 'sidebarNav.nativeContent',
              require: { minRole: ROLE.MEMBER },
            },
          },
          {
            path: ':id',
            element: PersonalVoiceFormPage,
            meta: {
              title: 'sidebarNav.nativeContent',
              require: { minRole: ROLE.MEMBER },
            },
          },
        ],
      },
      {
        path: ':id',
        element: NativeContentDetailPage,
        meta: {
          title: 'sidebarNav.nativeContent',
          require: { minRole: ROLE.MEMBER },
        },
      },
    ],
  },
]

export default routes
